<template>
	<section class="vx-row m-0 justify-center w-full bg-warning pb-24">
		<div class="vx-col w-full md:w-5/6 lg:w-5/6">
			<vx-card class="pb-6" style="margin-top: -6rem;">
				<div class="copy-button flex justify-end mb-6 md:mb-3">
					<input type="text" class="opacity-0" id="link" v-model="copyLink" />
					<vs-button
						class="rounded-none"
						size="small"
						@click.prevent="doCopy"
					>
					COPY LINK
					</vs-button>
				</div>
				<header class="flex justify-center mb-8">
					<img v-if="sahabat.user && sahabat.user.file !== null" :src="sahabat.user.file" alt="" class="w-48 rounded-full" />
					<img v-else src="/assets/images/sahabat-zx/charity.svg" alt="" class="w-48 rounded-full" />
				</header>
				<main class="flex flex-col justify-center mb-4 mx-auto mb-12">
					<h2 class="text-center mb-4"><strong>{{sahabat.user ? sahabat.user.name : sahabat.name}}</strong></h2>
					<h4 class="text-center mb-4"><strong>{{ sahabat.email }}</strong></h4>
					<h4 class="text-center mb-4"><strong>{{ sahabat.no_telp }}</strong></h4>
					<h4 class="text-center mb-4"><strong>{{ sahabat.website }}</strong></h4>
					<div v-if="sahabat.visi !== null" class="mb-4 text-center">
						<vs-divider></vs-divider>
						<h3 class="text-center mb-4"><strong>Visi</strong></h3>
						<div v-html="sahabat.visi"></div>
						<vs-divider></vs-divider>
					</div>
					<div v-if="sahabat.misi !== null" class="mb-4 text-center">
						<vs-divider></vs-divider>
						<h3 class="text-center mb-4"><strong>Misi</strong></h3>
						<div v-html="sahabat.misi"></div>
						<vs-divider></vs-divider>
					</div>
					
					<p class="text-center">
						{{ sahabat.keterangan }}
					</p>
				</main>
				<!-- List Campaign -->
				<sahabat-campaign :user_id="user_id" />
				<!-- / -->

				<!-- List Qurban -->
				<sahabat-qurban :user_id="user_id" :mitra_id="mitra_id" />
				<!-- / -->

				<!-- List Sos -->
				<sahabat-sos :user_id="user_id" />
				<!-- / -->

				<!-- Portal ZIS -->
				<div v-if="sahabat.status_lembaga !== null && sahabat.status_lembaga.id == allowedZis">
					<sahabat-zis :user_id="user_id" :sahabat="sahabat" />
				</div>
				<!-- / -->
			</vx-card>
		</div>
	</section>
</template>
<script>
	import { mapState } from 'vuex';
	import SahabatCampaign from './components/Campaign.vue';
	import SahabatSos from './components/Sos.vue';
	import SahabatZis from './components/Zis.vue';
	import SahabatQurban from './components/Qurban.vue';
	import { ShareNetwork } from 'vue-social-sharing';

	const allowedZis = 1;
	let meta = [
		{ property: 'og:url', content: process.env.VUE_APP_FE },
		{ property: 'og:type', content: 'website' },
		{ property: 'og:title', content: 'Website Zakat Express' },
		{ property: 'og:image', content: '/zx.png' }
	];

	export default {
		name: 'sahabat-zx-lp',
		metaInfo: {
			meta
		},
		components: {
			ShareNetwork,
			SahabatCampaign,
			SahabatSos,
			SahabatZis,
			SahabatQurban
		},
		data: () => ({
			mitra: [],
			sahabat: {},
			user_id: 0,
			mitra_id: null,
			copyLink: null,
			allowedZis
		}),
		methods: {
			doCopy() {
				document.querySelector('#link').focus()
				document.querySelector('#link').select()
				document.execCommand('copy')
				this.$vs.notify({
					title: 'Link Sahabat ZX berhasil disalin',
					text: '',
					color: 'dark',
					position: 'bottom-right'
				})
			}
		},
		computed: {
			...mapState('mitra', ['choiceMitra'])
		},
		created() {
			this.copyLink = window.location.href

			this.mitra = [...this.choiceMitra]
			
			// get id from slug
			const arrSlug = this.$route.params.slug_and_id.split('-'),
					id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString()
			const sahabat = this.mitra.find(item => item.id == id)
			if(sahabat) {
				Object.assign(this.sahabat, sahabat)
				if(this.sahabat.user && this.sahabat.user.file !== null) {
					// this.sahabat.user.file = process.env.VUE_APP_STORAGE + '/' + this.sahabat.user.file
				}

				this.user_id = this.sahabat.user.id;
				this.mitra_id = this.sahabat.id;
				meta[0].content = `${process.env.VUE_APP_FE}/sahabat-zx/${this.$route.params.slug_and_id}`;
				meta[2].content = this.sahabat.user ? `Sahabat ZX - ${this.sahabat.user.name}` : 'Sahabat ZX';

				// Update meta via DOM
				const titleNodeList = document.querySelectorAll('meta[property="og:title"]'),
					titleArray = [...titleNodeList],
					urlNodeList = document.querySelectorAll('meta[property="og:url"]'),
					urlArray = [...urlNodeList];
				
				titleArray.forEach(meta => meta.setAttribute('content', `Sahabat ZX - ${this.sahabat.user.name}`));
				urlArray.forEach(meta => meta.setAttribute('content', `${process.env.VUE_APP_FE}/sahabat-zx/${this.$route.params.slug_and_id}`));
			}
			else {
				const params = {
					start: 0
				}

				// get Mitra first
				this.$store.dispatch('mitra/getChoiceMitra', params)
				.then(data => {
					this.mitra = data.data

					const sahabat = this.mitra.find(item => item.id == id)
					if(sahabat) {
						Object.assign(this.sahabat, sahabat)
						this.user_id = this.sahabat.user.id;
						this.mitra_id = this.sahabat.id;
						meta[0].content = `${process.env.VUE_APP_FE}/sahabat-zx/${this.$route.params.slug_and_id}`;
						meta[2].content = this.sahabat.user ? `Sahabat ZX - ${this.sahabat.user.name}` : 'Sahabat ZX';

						// Update meta via DOM
						const titleNodeList = document.querySelectorAll('meta[property="og:title"]'),
							titleArray = [...titleNodeList],
							urlNodeList = document.querySelectorAll('meta[property="og:url"]'),
							urlArray = [...urlNodeList];
						
						titleArray.forEach(meta => meta.setAttribute('content', `Sahabat ZX - ${this.sahabat.user.name}`));
						urlArray.forEach(meta => meta.setAttribute('content', `${process.env.VUE_APP_FE}/sahabat-zx/${this.$route.params.slug_and_id}`));
					}
				})
				.catch(e => {
					if(e.response) {
						console.error(e.response)
					}

					return false
				});
			}
		}
	}
</script>